export default __webpack_public_path__ + "static/media/ic_twitter.df12961e.svg";